module.exports = __webpack_public_path__ + "img/U6.c8a0b819.png";